<script>

import Layout from "../../../layouts/main";
import appConfig from "../../../../app.config";
import Detail from "@/views/service-company/detail/detail";
import i18n from "@/i18n";

export default {
  page: {
    title: i18n.global.t('page.service-company'),
    meta: [{
      name: "description",
      content: appConfig.description,
    },],
  },
  data() {
    return {
      companyId: null,
    };
  },
  components: {
    Layout,
    Detail,
  },
  computed: {

  },
  watch: {

  },
  beforeMount() {
    this.companyId = this.$route.params.id
  },

  methods: {

  },
};
</script>

<template>
  <Layout>
    <detail
        :company-id="companyId"
        source="business-partner"
        account-permission-code="company.account.get"
        account-edit-permission-code="company.account.get"
        other-permission-code="company.get"
        other-edit-permission-code="company.get"
    ></detail>
  </Layout>

</template>
<style scoped>

</style>
